import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { useRepasseSetorialDetailsDispatch } from './repasse-setorial-details-context';
import { ACTION_TYPES } from './repasse-setorial-details-reducer';

export const useRepasseSetorialDetailsController = () => {
  const dispatch = useRepasseSetorialDetailsDispatch();

  const loadRepasseSetorialDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getRepasseSetorial(id);

      dispatch({ type: ACTION_TYPES.setRepasseSetorialDetails, payload: response });
    } catch (error) {
      console.error('Error loading repasse setorial details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes do repasse setorial' });
      dispatch({ type: ACTION_TYPES.setRepasseSetorialDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearRepasseSetorialDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setRepasseSetorialDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportRepasseSetorialDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportRepasseSetorialDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadRepasseSetorialDetails,
    clearRepasseSetorialDetails,
    exportRepasseSetorialDetail,
  };
};
